/* global wx */
// 设置微信JSSDK config
import { WX_APPID } from './config/wx';
import ajax from './util.ajax';
import Env from './util.env.js';
var isWxConfigAlready = false; // 配置微信jssdk

function config_wx_jssdk(res, wx_appid) {
  var jsApiList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var openTagList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (isWxConfigAlready) {
    return;
  }

  if (res && res.signature && res.nonceStr && res.timestamp) {
    wx.config({
      debug: false,
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: wx_appid || WX_APPID,
      // 必填，公众号的唯一标识
      timestamp: res.timestamp,
      // 必填，生成签名的时间戳
      nonceStr: res.nonceStr,
      // 必填，生成签名的随机串
      signature: res.signature,
      // 必填，签名
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'].concat(jsApiList),
      // 必填，需要使用的JS接口列表
      openTagList: openTagList // 必填，需要使用的开放标签列表

    });
    wx.ready(function () {
      isWxConfigAlready = true;
    });
  }
}
/**
 * 获取微信签名
 * @param errCount
 */


function getWXSignature(errCount, wx_appid, jsApiList, openTagList) {
  errCount = errCount || 0;
  var url = encodeURIComponent(window.location.origin + window.location.pathname + window.location.search); // https://www.didachuxing.com/hapis/api/rs/user/wx/h5/signature
  // 新项目结构，参数有等号就接口403
  // 截取掉最后的等号不影响参数，固截掉

  var domainName;

  if (location.host.includes(':') && /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(location.host.split(':')[0]) || location.host.includes('localhost')) {
    domainName = '';
  } else {
    domainName = 'https://capis.didapinche.com'; // if (Env.isEnvOnline) {
    //   domainName = 'https://capis.didapinche.com';
    // } else if (Env.isEnvECS) {
    //   domainName = 'https://capis-ecs.didapinche.com';
    // } else {
    //   domainName = 'https://capis-test.didapinche.com';
    // }
  }

  var btoaurl = window.btoa(url);
  ajax.get(domainName + '/web/user/wx/h5/signature', {
    params: {
      url: btoaurl
    }
  }).then(function (res) {
    console.log('[getWXSignature] success => ', res);
    var data = res.data;

    if (data && data.signature && data.nonceStr && data.timestamp) {
      config_wx_jssdk(data, wx_appid, jsApiList, openTagList);
    } else {
      if (errCount < 3) {
        return getWXSignature(++errCount, wx_appid, jsApiList, openTagList);
      } else {
        return false;
      }
    }
  });
}

export function configWXSignature(jsApiList, wx_appid, openTagList) {
  getWXSignature(0, wx_appid, jsApiList, openTagList);
}
/**
 * 微信二次分享
 * @param title 分享标题
 * @param desc 分享内容
 * @param link 分享链接 该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
 * @param imgUrl 分享图标
 * @param success 成功回调
 * @param fail 失败回调
 * @param cancel 取消回调
 */

export function shareByWX() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      title = _ref.title,
      desc = _ref.desc,
      link = _ref.link,
      imgUrl = _ref.imgUrl,
      _success = _ref.success,
      _fail = _ref.fail,
      _cancel = _ref.cancel,
      wx_appid = _ref.wx_appid,
      jsApiList = _ref.jsApiList,
      openTagList = _ref.openTagList;

  if (!isWxConfigAlready) {
    getWXSignature(0, wx_appid, jsApiList, openTagList);
  }

  wx.ready(function () {
    // 分享的数据集合
    var shareInfo = {
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl
    }; // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容

    wx.updateAppMessageShareData(Object.assign(shareInfo, {
      success: function success(msg) {
        typeof _success === 'function' && _success(msg);
      },
      fail: function fail(msg) {
        console.log('wx.updateAppMessageShareData失败');
        typeof _fail === 'function' && _fail(msg); // return resolve(null);
      },
      cancel: function cancel(msg) {
        console.log('wx.updateAppMessageShareData取消');
        typeof _cancel === 'function' && _cancel(msg); // return resolve(null);
      }
    })); // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容

    wx.updateTimelineShareData(Object.assign(shareInfo, {
      success: function success(msg) {
        typeof _success === 'function' && _success(msg);
      },
      fail: function fail(msg) {
        console.log('wx.updateTimelineShareData失败');
        typeof _fail === 'function' && _fail(msg); // return resolve(null);
      },
      cancel: function cancel(msg) {
        console.log('wx.updateTimelineShareData取消');
        typeof _cancel === 'function' && _cancel(msg); // return resolve(null);
      }
    })); // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）

    wx.onMenuShareTimeline(Object.assign(shareInfo, {
      success: function success(msg) {
        typeof _success === 'function' && _success(msg);
      },
      fail: function fail(msg) {
        console.log('wx.onMenuShareTimeline失败');
        typeof _fail === 'function' && _fail(msg); // return resolve(null);
      },
      cancel: function cancel(msg) {
        console.log('wx.onMenuShareTimeline取消');
        typeof _cancel === 'function' && _cancel(msg); // return resolve(null);
      }
    })); // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）

    wx.onMenuShareAppMessage(Object.assign(shareInfo, {
      type: '',
      // 分享类型,music、video或link，不填默认为link
      dataUrl: '',
      // 如果type是music或video，则要提供数据链接，默认为空
      success: function success(msg) {
        typeof _success === 'function' && _success(msg);
      },
      fail: function fail(msg) {
        console.log('wx.onMenuShareAppMessage失败');
        typeof _fail === 'function' && _fail(msg); // return resolve(null);
      },
      cancel: function cancel(msg) {
        console.log('wx.onMenuShareAppMessage取消');
        typeof _cancel === 'function' && _cancel(msg); // return resolve(null);
      }
    }));
  });
}